import { Empty as AntEmpty, type EmptyProps as AntEmptyProps } from 'antd';
import React from 'react';

type EmptyProps = Pick<
  AntEmptyProps,
  'children' | 'description' | 'image' | 'imageStyle'
>;

function Empty(props: EmptyProps): JSX.Element {
  return <AntEmpty {...props} />;
}

const EmptyWithStatics = Object.assign(Empty, {
  PRESENTED_IMAGE_DEFAULT: AntEmpty.PRESENTED_IMAGE_DEFAULT,
  PRESENTED_IMAGE_SIMPLE: AntEmpty.PRESENTED_IMAGE_SIMPLE
});

export default EmptyWithStatics;
export type { EmptyProps };
